import { useRoutes } from 'react-router-dom'
import StartScanScreen from '../scan/startScanScreen'
import { AdminScreen } from '../admin/adminScreen'
import { UploadIssues } from '../uploadIssues/uploadIssues'
import Executions from '../executions/Executions'
import FastTrack from '../fasttrack/FastTrack'

export const useAppRoutes = () =>
  useRoutes([
    { path: process.env.PUBLIC_URL, element: <StartScanScreen /> },
    { path: `${process.env.PUBLIC_URL}/admin`, element: <AdminScreen /> },
    {
      path: `${process.env.PUBLIC_URL}/uploadIssues`,
      element: <UploadIssues />,
    },
    {
      path: `${process.env.PUBLIC_URL}/executions`,
      element: <Executions />,
    },
    {
      path: `${process.env.PUBLIC_URL}/fasttrack`,
      element: <FastTrack />,
    },
  ])
